import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl text-primary-500"></i>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-950">星空影院</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              聚合热播电视剧、高分剧集全集在线观看，韩剧在线、美剧在线、国产剧大全免费追剧，超清画质不缓冲流畅播放。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/korean" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">韩剧在线</Link>
              <Link to="/category/american" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">美剧在线</Link>
              <Link to="/category/chinese" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">国产剧大全</Link>
              <Link to="/category/japanese" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">日剧推荐</Link>
              <Link to="/category/thai" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">泰剧热播</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">剧集大全</Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">联系方式</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-600">
              <span>邮箱：service@xingkongyingyuan.com</span>
              <span>客服热线：400-888-6666</span>
              <span>工作时间：周一至周日 9:00-21:00</span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 星空影院 版权所有 | 本站内容仅供学习参考
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}